<template>
  <v-snackbar
    v-model="getSnackbarInfo.enable"
    :color="getSnackbarInfo.color"
    :timeout="getSnackbarInfo.timeout"
    :top="getSnackbarInfo.top"
    :bottom="getSnackbarInfo.bottom"
    :left="getSnackbarInfo.left"
    :right="getSnackbarInfo.right"
    :vertical="getSnackbarInfo.vertical"
    :multi-line="getSnackbarInfo.multiline"
  >
    {{ getSnackbarInfo.text }}
    <v-btn
      dark
      flat
      @click="close()"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      snackbar: false,
      color: "success",
      mode: "",
      timeout: 4000
    };
  },
  computed: {
    ...mapGetters(["getSnackbarInfo"])
  },
  methods: {
    close() {
      let snackbarInfo = this.getSnackbarInfo;
      snackbarInfo.enable = false;
      this.$store.dispatch("changeSnackbarInfo", snackbarInfo);
    }
  }
};
</script>
